import { ActivityProduct } from '@/api/Cart/cart.interfaces';
import { Money } from '@libs/money/money.interfaces';
import { t } from '@shared/helpers/translation';

export const mapActivitySubLabel = (product: ActivityProduct): string => {
    const tickets = product.Tickets.length;
    return `${tickets} ${t({
        key: 'shared.ticket',
        keyPlural: 'shared.tickets',
        count: tickets,
    })}`;
};

export const mapActivityPrice = (product: ActivityProduct): Money => {
    return {
        Amount: product.Price.Amount,
        Currency: product.Price.Currency,
    };
};
